// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { environmentShared } from './environment.shared';

export const environment = {
  production: false,
  baseUrl: 'https://processor.bwrm.com',
  apiBaseUrl: environmentShared.apiBaseUrl,
	lastVisitedAddressKey: environmentShared.lastVisitedAddressKey,
  environmentName: environmentShared.environmentName,
  apiKey: environmentShared.apiKey,
  assetServiceUrl: environmentShared.assetServiceUrl,
  version: environmentShared.version,
  updateDate: environmentShared.updateDate
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
